"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AggregateStatusReporter {
    constructor() {
        this.callbacks = new Set();
    }
    addCallback(callback = () => { }) {
        this.callbacks.add(callback);
        callback(this.currentMessage);
    }
    callback(message) {
        this.currentMessage = message;
        this.callbacks.forEach(elt => {
            elt(message);
        });
    }
}
exports.default = AggregateStatusReporter;
